module.exports = __webpack_public_path__ + "static/img/boxTool-2.9549cd7.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/boxTool-2.svg
// module id = rrkj
// module chunks = 1